module.exports = __webpack_public_path__ + "static/media/Mobileseizonlogo.07abaa6a.PNG";